var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 27 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8334 3.49998C26.8334 2.03331 25.6334 0.833313 24.1667 0.833313H2.83335C1.36669 0.833313 0.166687 2.03331 0.166687 3.49998V19.5C0.166687 20.9666 1.36669 22.1666 2.83335 22.1666H24.1667C25.6334 22.1666 26.8334 20.9666 26.8334 19.5V3.49998ZM24.1667 3.49998L13.5 10.1666L2.83335 3.49998H24.1667ZM24.1667 19.5H2.83335V6.16665L13.5 12.8333L24.1667 6.16665V19.5Z",
    fill: "#858585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.0df4955536eed26d1a04ddcbad4bc534.svg";
export { ForwardRef as ReactComponent };